import { resolve } from "path";
import { pathToFileURL } from "url";
var toAbsolute = function toAbsolute2(p) {
  return resolve(process.cwd(), p);
};
var toAbsoluteUrl = function toAbsoluteUrl2(p) {
  return pathToFileURL(resolve(process.cwd(), p)).href;
};
export {
  toAbsolute,
  toAbsoluteUrl
};
//# sourceMappingURL=toAbsolute.js.map
